// extracted by mini-css-extract-plugin
export default {"loading":"Page_loading__-ycl2","grow":"Page_grow__XYMZG"};